import { useLocalize } from '@/app/api';
import { RootState } from "@/app/store"

import zh from "@/app/i18n/zh.json"
import en from "@/app/i18n/en.json"
import cn from "@/app/i18n/cn.json"
import { Lang } from "@/app/appSlice"

const dict: { [k in Lang]: { [key: string]: string } } = {
  zh,
  en,
  cn,
}

type availLang = { 
  code: Lang
  display: string
  suffix: string
}

export const availableLang: availLang[] = [
  {
    code: "zh",
    display: "繁",
    suffix: "Zh"
  },
  {
    code: "en",
    display: "EN",
    suffix: ""
  },
  // {
  //   code: "cn",
  //   display: "简",
  // },
]

export const useTranslate = () => {
  const lang = useAppSelector((state: RootState) => state.app.lang)
  return (key: string, replace?:{[key:string]:any}) => {
    if (dict[lang][key]) {
      let returnVal = dict[lang][key]
      if(replace){
        const replaceKeys = Object.keys(replace)
        replaceKeys.forEach(k=>returnVal = returnVal.replace(new RegExp(`{{${k}}}`),replace[k]))
      }
      return returnVal
    }
    return key
  }
}

export const useTranslateExist = () => {
  const lang = useAppSelector((state: RootState) => state.app.lang)
  return (key: string) => {
    return !!dict[lang][key]
  }
}
